import { render, staticRenderFns } from "./CallLogs.vue?vue&type=template&id=4a14d353&scoped=true"
import script from "./CallLogs.vue?vue&type=script&lang=js"
export * from "./CallLogs.vue?vue&type=script&lang=js"
import style0 from "./CallLogs.vue?vue&type=style&index=0&id=4a14d353&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a14d353",
  null
  
)

export default component.exports